<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 19:09:22
-->
<template>
  <section>
    <div class="role">
      <!-- <i class="fa-line"></i> -->
      <div class="roleRight" style="border-left: 0;padding-bottom: 30px">
        <div class="roleRight_Top">
          <el-input
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              v-if="searchShow"
              @keyup.enter.native="QueryOrganizationManagement"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="QueryOrganizationManagement"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data car_post">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              row-key="orgId"
              default-expand-all
              style="width: 100%; max-width: 1400px"
              :tree-props="{ children: 'orgs' }"
          >
            <el-table-column prop="name" label="名称"  style="text-align: left !important;"></el-table-column>
            <el-table-column prop="seq" width="100px" label="排序"></el-table-column>
            <el-table-column prop="status" width="100px" label="状态">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column v-if="deleteShow || editShow || launchShow" fixed="right" label="操作" width="240">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button>
                <el-button
                    v-if="launchShow"
                    @click="handleLaunchClick(scope.row)"
                    plain
                    size="small"
                >投放
                </el-button>
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        :title="
        clickType == 'addgroup'
          ? '新增组织组信息'
          : clickType == 'addNext'
          ? '新增组织信息'
          : clickType == 'edit'
          ? '编辑组织组'
          : clickType == 'change'
          ? '修改组织信息'
          : ' 菜单分配'
      "
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="460px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <!-- edit group ||    add child -->
          <el-form-item
              class="item"
              label="上级："
              style="position: relative"
          >
            <span class="clear_icon_items">*</span>
            <el-select
                ref="selectReport"
                v-model="dictDataSelect"
                clearable
                placeholder="选择上级"
            >
              <el-option
                  :key="params.orgId"
                  :label="params.name"
                  :value="params.orgId"
                  style="height: auto"
              >
                <el-tree
                    :data="treeList"
                    node-key="orgId"
                    ref="tree"
                    default-expand-all
                    :props="defaultProps"
                    :render-after-expand="true"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- add group -->
          <el-form-item
              class="item"
              label="名称："
              prop="name"
          >
            <el-input
                clearable
                placeholder="请填写组织名称(10字以内) "
                v-model="params.name"
                maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="排序："
          >
            <el-input
                clearable
                placeholder="请填写排序"
                v-model="params.seq"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="说明："
          >
            <el-input type="textarea" :rows="4" placeholder="最长为200个字符" v-model="params.descr"
                      maxlength="200"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>

    <!-- 渠道配置 -->
    <el-dialog
        title="投放账号管理"
        :visible.sync="channelDialogVisible"
        :close-on-click-modal="false"
        width="1070px"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-loading="loading">
        <div class="channel_items" style="align-items: center">
          <div class="titles">名称：</div>
          <div>{{ launchInfo.name }}</div>
          <el-button type="primary" @click="changBindShow" style="margin-left: 20px">绑定</el-button>
        </div>
        <div class="channel_items">
          <div class="titles">渠道账户：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.orgChannels.length" v-for="(item,index) in accountnNumberList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.orgChannels" :key="indexs">
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button @click="deleteBindAccount(items)" size="mini" type="text" plain>解绑</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
        title="投放账号绑定"
        :visible.sync="releaseAccountBinding"
        :close-on-click-modal="false"
        width="1070px"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-loading="loading">
        <div class="channel_items" style="align-items: center">
          <div class="titles">名称：</div>
          <div>{{ launchInfo.name }}</div>
        </div>
        <div class="channel_items">
          <div class="titles">渠道账户：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.orgChannels.length" v-for="(item,index) in channelList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.orgChannels" :key="indexs">
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button v-if="items.bind==0" @click="addBindAccount(items)" size="mini" type="text" plain>添加
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--绑定信息详情-->
    <el-dialog
        title="绑定信息"
        :visible.sync="bindingInfo"
        :close-on-click-modal="false"
        width="580px"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-loading="loading" style="padding-bottom:15px">
        <div class="items">
          <div class="left_name">名称：</div>
          <div class="right_content">{{ accountBindInfo.channelTypeName }}（{{ accountBindInfo.code }}）</div>
        </div>
        <div class="info_tab_tas">
          <div class="items">
            <div class="left_name"> 账号：</div>
            <div class="right_content">{{ accountBindInfo.account }}</div>
          </div>
          <div class="items">
            <div class="left_name">投放方式：</div>
            <div class="right_content">{{ accountBindInfo.putWayName }}</div>
          </div>
        </div>
        <div class="items" v-if="accountBindInfo.orgName">
          <div class="left_name">绑定部门：</div>
          <div class="right_content">{{ accountBindInfo.orgName }}</div>
        </div>
        <div class="items" v-if="accountBindInfo.number">
          <div class="left_name">绑定业务员：</div>
          <div class="right_content">{{ accountBindInfo.name }}（{{ accountBindInfo.number }}）</div>
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";
import {isEmpty} from '../../utils/tools';

export default {
  data() {
    return {
      PAGE_SIZE,
      loading: false,

      //上一级展示的词语
      dictDataSelect: "",
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      defaultProps: {
        children: "orgs",
        label: "name",
      },
      permissionData: [], //组织--菜单树
      treeList: [],
      treeList_one: [],
      optionList: [
        {
          value: "1",
          label: "修改",
        },
        {
          value: "2",
          label: "删除",
        },
      ],
      search: {},
      // input_search: "",
      // value: "", //select1
      value1: "", //select2
      value2: true,

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "change"}],
        orgId: [
          {required: true, message: "请选择上级", trigger: "change"},
        ],
      }, //表单验证提示

      tableData: [], //二级--组织列表

      trees: {
        tree: true,
      },

      childArr: [], //点击选择的orgId

      channelDialogVisible: false,
      launchInfo: {},
      releaseAccountBinding: false,
      channelList: [],
      accountnNumberList: [],
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      launchShow: false,
      bindingInfo: false,
      accountBindInfo: {}
    };
  },
  created() {
    this.getRoleListTree();
    this.getRoleList();
    this.getPermissionData(); //获取所有菜单权限项目
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.dictDataSelect = ""; //上一级回显数据清除
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    async bindInfo(e) {
      this.loading = true;
      const {data: resData} = await this.$get(`/channel/account/bind/info?channelAccountId=` + e.channelAccountId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.accountBindInfo = resData.data
      this.bindingInfo = true
    },

    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:organization:launch') {
            this.launchShow = true
          }
          if (item.code == 'system:organization:query') {
            this.searchShow = true
          }
          if (item.code == 'system:organization:add') {
            this.addShow = true
          }
          if (item.code == "system:organization:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:organization:edit") {
            this.editShow = true
          }
          if (item.code == "system:organization:status") {
            this.statusShow = false
          }
        })
      }
    },
    deleteBindAccount(e) {
      this.$confirm("确认解除当前绑定账号, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete("/org/channel/bind/status",
            {
              data: {
                channelAccountId: e.channelAccountId,
                orgId: this.launchInfo.orgId
              }
            },
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.changBindShow(1);
        this.handleLaunchClick(this.launchInfo)
        this.releaseAccountBinding = false
        this.$message.success("解绑成功!");
      })
    },
    // 绑定账号？
    addBindAccount(e) {
      let obj = {
        channelAccountId: e.channelAccountId,
        orgId: this.launchInfo.orgId
      }
      this.$confirm("确认绑定当前投放账号, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "/org/channel/bind/status",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.handleLaunchClick(this.launchInfo)
        this.changBindShow();
        this.$message.success("添加成功!");
      })
    },
    //已绑定列表
    async handleLaunchClick(e) {
      this.loading = true;
      this.launchInfo = e
      const {data: resData} = await this.$get(`/org/channel/bind/list?orgId=` + e.orgId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.accountnNumberList = resData.data
      this.channelDialogVisible = true
    },
    //可绑定列表
    async changBindShow(e) {
      this.loading = true;
      const {data: resData} = await this.$get(`/org/channel/list`);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.channelList = resData.data
      if (e != 1) {
        this.releaseAccountBinding = true
      }
    },


    QueryOrganizationManagement() {
      this.page.pageNo = 1
      this.getRoleListTree()
    },
    /**
     *  get role List  //and table  //left menu  //search
     */
    async getRoleListTree(node) {
      let http = "/org/list?tree=true&paging=false";
      this.loading = true;
      //组织列表
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
      // this.page.count = resData.page.count;
    },
    async getRoleList() {
      //组织组--树
      const {data: resData} = await this.$get(`/org/list?tree=true&`);
      this.treeList = resData.data;
    },
    async getPermissionData() {
      const {data: resData} = await this.$get("/menus");
      if (resData.result != 200) return;
      this.permissionData = resData.data;
    },

    //switch状态改变 --接口 修改组织状态
    handleSwitch(index) {
      //interface
      this.$put(`/org/info/status/${this.tableData[index].orgId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "change") {
        //修改  change
        this.params = {
          orgId: row.orgId,
          name: row.name,
          descr: row.descr,
          parentId: row.parentId,
          seq:row.seq,
        };
        // id:当前节点id
        if(row.nodeLevel!=1){
          setTimeout(()=>{
            this.dictDataSelect = this.$refs.tree.getNode(
                row.orgId
            ).parent.data.name;
          },500)
        }
      } else {
        //添加
        this.dictDataSelect = "";
        this.params = {};
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = {
          name: this.params.name,
          parentId: this.params.parentId,
          orgId: this.params.orgId,
          descr: this.params.descr,
          seq:parseInt(this.params.seq),
        };
        if (!valid) return;

        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            if (this.dictDataSelect == "") passData.parentId = 0;
            passData.orgId = "";
            const {data: resData} = await this.$post("/org/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.getRoleList();
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改组织
              if (this.dictDataSelect == "") {
                passData.parentId = 0;
              }
              const {data: resData} = await this.$put("/org/info", passData, {
                headers: {
                  isLoading: true,
                },
              });
              if (resData.result != 200) return;
              this.getRoleListTree(); //重新获取数据
              this.getRoleList();

              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //菜单分配
            }
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(`/org/info/${row.orgId}`, {
          headers: {
            isLoading: true,
          },
        });
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.getRoleList();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },

    // 选择组织组
    handleNodeClick: function (node) {
      //node是点击的父级别
      this.dictDataSelect = node.name;

      if (this.clickType == "change") {
        this.params.parentId = node.orgId;
      } else {
        this.params.parentId = node.orgId;
      }
      this.$refs.selectReport.blur();
    },

    // 递归 函数：获取所有子节点的orgId
    getAllChild(obj) {
      if (Object.prototype.hasOwnProperty.call(obj, "orgs")) {
        for (const item of obj.orgs) {
          if (Object.prototype.hasOwnProperty.call(item, "orgs")) {
            this.childArr.push(item.orgId);
            this.getAllChild(item);
          } else {
            this.childArr.push(item.orgId);
          }
        }
        this.getAllChild(obj.orgs);
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -63px;
  top: 0;
}
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    padding-right: 15px;
    width: auto;
    min-width: 180px;
    transition: all 0.3s linear;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  &Right {
    border-left: 1px solid #ccc;
    padding-left: 15px;
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.channel_items {
  display: flex;
  margin-bottom: 15px;

  .titles {
    width: 80px;
    text-align: right;
  }
}

.table_cou {
  height: auto;
  width: calc(100% - 80px);

  .tab_header_th {
    height: 30px;
    border: 1px solid rgba(231, 231, 231, 1);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-left: 1px solid rgba(231, 231, 231, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .qutuns {
      width: 100px;
    }

    .names {
      width: 80px;
    }

    .name_box_auto {
      width: 220px;
    }

    .code_box {
      width: 100px;
    }

    .post_inof {
      width: 80px;
    }

    .inde_auto {
      width: 50px;
    }

    .comtemts {
      width: 120px;
    }
  }

  .tab_body_content {
    .tab_content_td {
      display: flex;
      border: 1px solid rgba(231, 231, 231, 1);
      border-top: none;
      box-sizing: border-box;
      min-height: 30px;
      border-bottom: none;
    }

    .right_contents {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 80px);

      .right_items {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 30px;
        border-bottom: 1px solid rgba(231, 231, 231, 1);

        div {
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-left: 1px solid rgba(231, 231, 231, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .account_index {
          width: 50px;
        }
      }

      .account_box {
        width: 200px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
      }

      .contun_box_c {
        width: 100px;
        border-left: 1px solid rgba(231, 231, 231, 1);

        .box_icons {
          padding: 5px 10px;
          font-size: 12px;
          color: #ffffff;
          background-color: #3a8ee6;
          border-radius: 4px;
        }

        .active_none {
          background-color: rgba(0, 0, 0, 0.1);
          color: #606266;
        }
      }

      .account_name {
        width: 100px;
        padding: 0 10px;
      }

      .account_code {
        width: 100px;
      }

      .account_putWay {
        width: 80px;
      }

      .account_des {
        width: 100px;
      }
    }

    .left_contents {
      width: 80px;
      border-bottom: 1px solid rgba(231, 231, 231, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.items {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .left_name {
    width: 120px;
    text-align: right;

  }
}

.info_tab_tas {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.roleRight .car_post .el-table .el-table_1_column_1 {
  text-align: left !important;
}
.roleRight .car_post .el-table tbody tr td:nth-child(1){
  text-align: left !important;
}
.roleRight .car_post .el-table .el-table_1_column_1 {
  text-align: left !important;

  .disabled_tab {
    .el-switch__core {
      background-color: #606266 !important;
      border-color: #606266 !important;
    }
  }
}

</style>